import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  id: string;
  data: any; //TODO: fix type;
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  id: "",
  data: null,
};

const getEmployeeLeaveDetailSlice = createSlice({
  name: "getEmployeeLeaveDetail",
  initialState,
  reducers: {
    setEmployeeLeaveDetailId: (state, action: PayloadAction<string>) => {
      state.id = action.payload;
    },
    resetEmployeeLeaveDetailId: (state) => {
      state.id = "";
    },
    getEmployeeLeaveDetailStart: (
      state,
      action: PayloadAction<{ id: string }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getEmployeeLeaveDetailSuccess: (state, action: PayloadAction<any>) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },

    getEmployeeLeaveDetailFailed: (state, action) => {
      state.status = ReduxStateType.ERROR;
      state.data = action.payload;
    },
    updateDetailOrder: (state, action: PayloadAction<any>) => {
      if (!state.data) return;
      state.data.details = action.payload;
    },
    resetEmployeeLeaveDetail: () => {
      return { ...initialState };
    },
  },
});

export const {
  setEmployeeLeaveDetailId,
  resetEmployeeLeaveDetailId,
  getEmployeeLeaveDetailStart,
  getEmployeeLeaveDetailSuccess,
  getEmployeeLeaveDetailFailed,
  resetEmployeeLeaveDetail,
  updateDetailOrder,
} = getEmployeeLeaveDetailSlice.actions;

export default getEmployeeLeaveDetailSlice.reducer;
